import React from 'react';
import DelBox from '../comps/DelBox';
import AddDoctor from '../models/AddDoctor';
import AddTpa from '../models/AddTpa';

const TpaList = () => {
    return (
        <div class="page-content">
        <div class="container-fluid">
          
          <div class="row">
            <div class="col-lg-12">
              <div class="card" id="orderList">
                <div class="card-header border-0">
                  <div class="row align-items-center gy-3">
                    <div class="col-sm">
                      <h5 class="card-title mb-0">TPA List</h5>
                    </div>
                    <div class="col-sm-auto">
                      <div class="d-flex gap-1 flex-wrap">
                        <button type="button" class="btn btn-success add-btn" data-bs-toggle="modal" id="create-btn" data-bs-target="#showModal" fdprocessedid="jys8hw">
                          <i class="ri-add-line align-bottom me-1"></i> Add TPA </button>
                        <button class="btn btn-soft-danger" id="remove-actions">
                          <i class="ri-delete-bin-2-line"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body border border-dashed border-end-0 border-start-0">
                  <form>
                    <div class="row g-3">
                      <div class="col-xxl-5 col-sm-6">
                        <div class="search-box">
                          <input class="form-control search" placeholder="Search by name, email, contact..." type="text" fdprocessedid="ws635j"/>
                          <i class="ri-search-line search-icon"></i>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <br/>
                <div class="card-body pt-0">
                  <div>
                    
                    <div class="table-responsive table-card mb-1">
                      <table class="table table-nowrap align-middle" id="orderTable">
                        <thead class="text-muted table-light" >
                          <tr class="text-uppercase">
                            <th scope="col">
                              <div class="form-check">
                                <input class="form-check-input" id="checkAll" type="checkbox" value="option"/>
                              </div>
                            </th>
                            <th data-sort="id">S. No.</th>
                            <th data-sort="customer_name">Name</th>
                            <th data-sort="product_name">Address</th>
                            <th data-sort="product_name">PHNO</th>
                            <th data-sort="product_name">TPA Person Name</th>
                            <th data-sort="city">Action</th>
                          </tr>
                        </thead>
                        <tbody class="list form-check-all">
                          <tr>
                            <th scope="row">
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="option1" name="checkAll"/>
                              </div>
                            </th>
                            <td class="customer_name">1.</td>
                            <td class="product_name">MY Tpa</td>
                            <td class="date">lorems ispome is the</td>
                            <td class="date">3434434435</td>
                            <td class="date">Jai Singh</td>
                            <td>
                              <ul class="list-inline hstack gap-2 mb-0">
                                <li class="list-inline-item edit" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" aria-label="Edit" data-bs-original-title="Edit">
                                  <a href="#showModal" data-bs-toggle="modal" class="text-primary d-inline-block edit-item-btn">
                                    <i class="ri-pencil-fill fs-16"></i>
                                  </a>
                                </li>
                                <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" aria-label="Remove" data-bs-original-title="Remove">
                                  <a class="text-danger d-inline-block remove-item-btn" data-bs-toggle="modal" href="#deleteOrder">
                                    <i class="ri-delete-bin-5-fill fs-16"></i>
                                  </a>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="noresult">
                        <div class="text-center">
                          <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c"></lord-icon>
                          <h5 class="mt-2">Sorry! No Result Found</h5>
                          <p class="text-muted">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end">
                      <div class="pagination-wrap hstack gap-2">
                        <a class="page-item pagination-prev disabled" href="#">Previous</a>
                        <ul class="pagination listjs-pagination mb-0"></ul>
                        <a class="page-item pagination-next" href="#">Next</a>
                      </div>
                    </div>
                  </div>
                  <AddTpa/>
                 <DelBox/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default TpaList;
